import React from 'react';
import { Tooltip } from '@mui/material';

const CustomMRTTableColumnsWithTooltips = (columns) => {
    return columns.map((column) => ({
        ...column,
        Header: () => (
            <Tooltip title={column.header}>
                <span>{column.header}</span>
            </Tooltip>
        ),
    }));
};

export default CustomMRTTableColumnsWithTooltips;